import { Notebook, ShoppingBag, Bike, Info } from 'lucide-react';
import { motion } from 'framer-motion';

const OrderSummary = ({ totals }) => {
  return (
    <motion.div
      className="p-4 border-b bg-white"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.1 }}
    >
      <h2 className="font-semibold mb-3 text-gray-800">Order Summary</h2>

      <div className="space-y-2.5">
        <div className="flex justify-between items-center">
          <span className="flex items-center gap-2">
            <span className="text-gray-600 flex items-center gap-2">
              <Notebook className="h-4 w-4 text-gray-500" /> Items total
            </span>
            {totals.discount > 0 && (
              <span className="text-xs px-2 py-0.5 bg-blue-50 rounded-full text-blue-600 font-medium">
                Saved ₹{Math.floor(totals.discount)}
              </span>
            )}
          </span>
          <span className="flex items-center gap-2">
            {totals.discount > 0 && (
              <div className="line-through text-gray-400 text-sm">
                ₹{Math.floor(totals.mrpTotal)}
              </div>
            )}
            <div className="font-medium">₹{Math.ceil(totals.subtotal)}</div>
          </span>
        </div>

        <div className="flex justify-between items-center">
          <span className="text-gray-600 flex items-center gap-2">
            <ShoppingBag className="h-4 w-4 text-gray-500" />
            Platform Fees
          </span>
          <span>₹{totals.platformFees.toFixed(2)}</span>
        </div>

        <div className="flex justify-between items-center">
          <span className="flex items-center gap-1">
            <span className="text-gray-600 flex items-center gap-2">
              <Bike className="h-4 w-4 text-gray-500" /> Delivery charge
            </span>
            <div className="relative group">
              <Info className="h-3.5 w-3.5 text-blue-500 cursor-pointer" />
              <div className="absolute z-10 invisible group-hover:visible bg-white border border-gray-200 px-3 py-2 w-56 text-xs text-gray-600 -left-3 bottom-full rounded-md shadow-lg">
                Delivery charges may be subject to change based on seller and location.
              </div>
            </div>
          </span>
          <span>₹{totals.deliveryCharges.toFixed(2)}</span>
        </div>

        <div className="h-px bg-gray-100 my-1.5"></div>

        <div className="flex justify-between items-center pt-1">
          <span className="font-semibold text-gray-800">TO PAY</span>
          <span className="font-semibold text-xl text-gray-800">₹{Math.ceil(totals.total)}</span>
        </div>
      </div>

      {totals.minimumOrderValueMet && (
        <div className="mt-3 p-3 bg-amber-50 border border-amber-200 rounded-lg">
          <div className="flex items-start gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
            <div>
              <p className="text-sm text-amber-800">
                Minimum order value is{' '}
                <span className="font-semibold">₹{totals.minimumOrderValue}</span>
              </p>
              <p className="text-sm text-amber-800 mt-1">
                Add items worth{' '}
                <span className="font-semibold">
                  ₹{(totals.minimumOrderValue - totals.subtotal).toFixed(2)}
                </span>{' '}
                more to place your order
              </p>
            </div>
          </div>
          <div className="mt-2 w-full bg-gray-200 rounded-full h-1.5">
            <div
              className="bg-amber-500 h-1.5 rounded-full"
              style={{
                width: `${Math.min(100, (totals.subtotal / totals.minimumOrderValue) * 100)}%`,
              }}
            ></div>
          </div>
        </div>
      )}
    </motion.div>
  );
};

export default OrderSummary;
